import type { TKey } from './types';

const es: Record<TKey, string> = {
  'nav.library':            'Biblioteca',
  'nav.myBooks':            'Mis libros',
  'nav.credentials':        'Credenciales',
  'nav.mindmap':            'Mapa mental',
  'nav.reading':            'Lectura',
  'nav.upload':             'Upload',
  'nav.signin':             'Sign in',
  'nav.signout':            'Sign out',
  'nav.localeSelect':       'Language',

  'brand.sub':              'BookQuest',
  'onboard.welcome':        'Start with one book.',
  'onboard.welcomeSub':     'Pick a curated title or upload your own PDF — receive a four-layer mindmap, nine-tier adaptive quiz, and lifelong credentials.',
  'onboard.featureMapTitle':  'Four-layer mindmap',
  'onboard.featureMapBody':   'From surface narrative (L1) to the unsaid premises (L4) — a knowledge map drawn across four layers by AI.',
  'onboard.featureQuizTitle': 'Nine-tier adaptive quiz',
  'onboard.featureQuizBody':  'IRT-based difficulty (T1–T9) adjusts to your understanding in real time.',
  'onboard.featureCredTitle': 'Lifelong credentials',
  'onboard.featureCredBody':  'Every completion is issued as a W3C Verifiable Credential — externally verifiable, kept for life.',
  'onboard.ctaBrowse':      'Browse curated books',
  'onboard.ctaUpload':      'Upload my PDF',
  'onboard.signedOutHint':  'Sign in first to save your progress.',
  'onboard.ctaSignIn':      'Sign in / Sign up',
  'common.loading':         'Cargando…',
  'common.offline':         'sin conexión',
  'common.free':            'Gratis',
  'common.error':           'error',
  'common.back':            '← Biblioteca',
  'common.continue':        'Continuar',
  'common.submit':          'Enviar',
  'common.skip':            'Omitir',
  'common.next':            'Siguiente',
  'common.finish':          'Terminar',
  'common.startAssessment': 'Solo evaluar',
  'theme.label':            'Tema',
  'theme.light':            'Claro',
  'theme.dark':             'Oscuro',
  'theme.system':           'Sistema',
  'sound.label':            'Sonido',
  'sound.on':               'Activado',
  'sound.off':              'Desactivado',
  'api.error.badRequest':   'La solicitud fue rechazada.',
  'api.error.unauthorized': 'Inicia sesión para continuar.',
  'api.error.forbidden':    'No tienes acceso a este recurso.',
  'api.error.notFound':     'No encontrado — el recurso pudo moverse o eliminarse.',
  'api.error.tooLarge':     'Archivo demasiado grande. Inténtalo con menos de 100 MB.',
  'api.error.unsupported':  'Formato de archivo no admitido.',
  'api.error.rateLimited':  'Demasiadas solicitudes — vuelve a intentar en un momento.',
  'api.error.server':       'Error del servidor — vuelve a intentar pronto.',
  'api.error.network':      'Conexión de red perdida.',
  'api.error.unknown':      'Error desconocido',
  'a11y.skipToMain':        'Saltar al contenido principal',
  'notFound.kicker':        'No encontrado · 404',
  'notFound.titleLine1':    'Esta ruta',
  'notFound.titleLine2':    'no está en el estante.',
  'notFound.lead':          'El libro se movió, o la página nunca existió. Vuelve a la biblioteca y empieza de nuevo.',
  'notFound.pathLabel':     'Ruta solicitada',
  'notFound.cta':           'Volver a la biblioteca',
  'footer.tagline':         'Una biblioteca donde cada libro se vuelve mapa mental y credencial',
  'footer.navLabel':        'Navegación del pie',
  'footer.about':           'Acerca',
  'footer.privacy':         'Privacidad',
  'footer.terms':           'Términos',
  'footer.contact':         'Contacto',
  'reader.controls':              'Controles del lector',
  'reader.size':                  'Tamaño',
  'reader.theme':                 'Tema',
  'reader.previewFallback':       'La vista previa del cuerpo aún no está lista. Aparece cuando el libro se analiza.',
  'reader.stubNotice':            'Vista previa del entorno de lectura. El cuerpo completo llega en el próximo lanzamiento.',
  'reader.demoBody1':             'Los conceptos clave, contraargumentos, definiciones y acciones aparecen marcados por color mientras lees.',
  'reader.demoBody2':             'Los términos se definen en línea,',
  'reader.demoBody3':             'y lo que el lector debe intentar es',
  'reader.demoHighlightYellow':   'un concepto clave',
  'reader.demoHighlightCoral':    'un contraargumento',
  'reader.demoHighlightBlue':     'una definición',
  'reader.demoHighlightMint':     'una acción',
  'reader.aside.legendLabel':     'Leyenda de resaltado',
  'reader.aside.legendYellow':    'Concepto clave',
  'reader.aside.legendCoral':     'Contraargumento',
  'reader.aside.legendBlue':      'Definición',
  'reader.aside.legendMint':      'Acción',
  'reader.aside.metaLabel':       'Libro',
  'common.correct':         'Correcto.',
  'common.notQuite':        'Casi.',
  'common.save':            'Guardar para luego',
  'common.beginReading':    'Comenzar a leer',
  'common.openMindmap':     'Abrir mapa mental',
  'common.searchPlaceholder': 'Buscar por título, autor, ISBN…',

  'library.kicker':         'Colección inaugural · 100 vols',
  'library.heroLine1':      '100 para empezar,',
  'library.heroLine2':      'una estantería sin fin.',
  'library.heroSub':        'La colección inaugural — cada libro renace como un mapa mental de cuatro capas y una evaluación de nueve niveles.',
  'library.featured':       'Destacados del mes',
  'library.curatedCount':   'curados',
  'library.noBooks':        'Aún no hay libros curados. Usa el script de seed o la curación de administrador.',
  'library.filterAll':      'Todos',
  'library.filterClassics': 'Clásicos',
  'library.filterPhilosophy': 'Filosofía',
  'library.filterK5':       'K-5',
  'library.filter68':       '6-8',
  'library.filter912':      '9-12',

  'detail.previewNodes':    'Vista previa del mapa mental de cuatro capas.',
  'detail.sampledQuestions': 'Tres preguntas de muestra.',
  'detail.bookMissing':     'Faltan metadatos del libro.',
  'detail.noQuestions':     'Sin preguntas aún — la canalización puede estar procesando.',
  'detail.byAuthor':        'por',
  'detail.sourceLabel':            'Fuente',
  'detail.firstQuoteLabel':        'Primera cita',
  'detail.relatedCredentialLabel': 'Credencial relacionada',
  'detail.relatedCredentialBody':  'Este libro otorga una credencial de nivel Major al completarse.',
  'detail.pages':           'páginas',
  'detail.metaSeparator':   ' · ',

  'map.fourLayers':         'Cuatro capas',
  'map.navigation':         'Navegación',
  'map.surface':            'L1 Superficie',
  'map.argument':           'L2 Argumento',
  'map.concept':            'L3 Concepto',
  'map.meta':               'L4 Meta — lo no dicho',
  'map.notReady':           'Mapa no listo — la canalización aún puede estar procesando.',
  'map.loadingMap':         'Cargando mapa…',
  'map.selectNode':         'Selecciona un nodo para inspeccionar',
  'map.selectNodeSub':      'Cada nodo contiene una cita (L1), un argumento (L2), un concepto (L3) o una premisa silenciosa (L4).',
  'map.hoverHint':          'Pasa el cursor sobre un nodo',

  'quiz.of':                ' de ',
  'quiz.minRemaining':      'min restantes',
  'quiz.noQuestions':       'No hay preguntas disponibles.',
  'quiz.tier':              'Nivel',
  'quiz.celebration.kicker':         'Completado',
  'quiz.celebration.titleLine1':     'Un libro',
  'quiz.celebration.titleLine2':     'terminado.',
  'quiz.celebration.lead':           'Tu evaluación queda sellada en una credencial — conservada de por vida.',
  'quiz.celebration.correct':        'Correctas',
  'quiz.celebration.theta':          'θ final',
  'quiz.celebration.viewCredential': 'Ver credencial',

  'creds.kicker':           'Emitidas',
  'creds.heroLine':         'La estantería de tus',
  'creds.heroEm':           'lecturas ganadas',
  'creds.heroSub':          'Cada hito emitido como W3C Verifiable Credentials — verificable externamente, conservado de por vida.',
  'creds.master':           'Master ★',
  'creds.recent':           'Emitidas recientemente.',
  'creds.pastDays':         'últimos 30 días',
  'creds.noneYet':          'Completa un libro para ganar tu primera credencial.',
  'creds.urn':              'URN',
  'creds.issued':           'Emitida',
  'creds.anchor':           'Ancla',
  'creds.tier.micro':       'Micro',
  'creds.tier.standard':    'Estándar',
  'creds.tier.major':       'Mayor',
  'creds.tier.master':      'Maestro',
  'creds.tier.legendary':   'Legendario',
  'creds.count':            'credenciales',
  'creds.aside.tiersLabel':    'Escalera de 5 niveles',
  'creds.aside.tiersBody':     'Micro → Standard → Major → Master → Legendary. 80–100 acumuladas durante toda la vida.',
  'creds.aside.verifyLabel':   'Verificación externa',
  'creds.aside.verifyBody':    'Cada URN sigue el estándar W3C Verifiable Credentials — verificable por cualquier verificador compatible.',
  'creds.aside.standardLabel': 'Estándar',
  'creds.justIssued':          'Recién emitida',
  'creds.copied':              'Copiado',
  'creds.copyFailed':          'Copia fallida',
  'creds.share':               'Compartir',
  'creds.verifyExternally':    'Verificar externamente',
  'creds.verifierComing':      'El portal de verificación llega pronto.',
  'creds.shareNative':         'Compartir',
  'creds.print':               'Imprimir · PDF',
  'source.curated':         'curado',
  'source.user_upload':     'carga de usuario',
  'source.partner':         'socio',
  'source.public_domain':   'dominio público',
  'source.institution':     'institución',
  'auth.signinTitle':       'Sign in',
  'auth.signupTitle':       'Sign up',
  'auth.magicTitle':        'Magic link',
  'auth.email':             'Email',
  'auth.password':          'Password',
  'auth.signin':            'Sign in',
  'auth.signup':            'Create account',
  'auth.sendMagic':         'Send magic link',
  'auth.switchToSignup':    'New here? Create account',
  'auth.switchToSignin':    'Already have an account? Sign in',
  'auth.switchToMagic':     'Use magic link instead',
  'auth.notConfiguredBanner': 'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in packages/web-app/.env.local.',
  'auth.checkEmail':        'Check your email to confirm your account.',
  'auth.magicSent':         'Magic link sent — check your email.',
  'auth.working':           'Working…',
  'auth.aside.whyLabel':       'Por qué BookQuest',
  'auth.aside.why1':           'Un libro se convierte en un mapa mental de 4 capas.',
  'auth.aside.why2':           'Una evaluación de 9 niveles mide la comprensión lectora.',
  'auth.aside.why3':           'Las credenciales se acumulan de por vida.',
  'auth.aside.privacyLabel':   'Privacidad',
  'auth.aside.privacyBody':    'Tus datos de lectura son solo tuyos.',

  'upload.title':           'Upload a book',
  'upload.help':            'PDFs only. The system de-duplicates globally — if anyone has already processed this file you get instant free access.',
  'upload.fileLabel':       'PDF file',
  'upload.countryLabel':    'Country (for pricing)',
  'upload.submit':          'Upload',
  'upload.submitting':      'Uploading…',
  'upload.chooseFirst':     'Choose a PDF first.',
  'upload.failed':          'Upload failed',
  'upload.resultTitle':     'Result',
  'upload.dedupeStatus':    'De-dup status',
  'upload.paymentStatus':   'Payment status',
  'upload.amount':          'Amount',
  'upload.jobId':           'Job ID',
  'upload.eta':             'ETA',
  'upload.watchProgress':   'Watch progress',
  'job.title':              'Progreso del análisis',
  'job.processing':         'Analizando el libro y generando preguntas…',
  'job.stage':              'Etapa',
  'job.cost':               'Costo hasta ahora',
  'job.done':               'Completado',
  'job.failed':             'Algo salió mal durante el procesamiento',
  'job.openBook':           'Ir al libro',
  'job.eta':                'Suele tardar ~20 min. Sigue en segundo plano si cierras esto.',
  'upload.aside.formatLabel':  'Formatos admitidos',
  'upload.aside.formatBody':   'PDF con texto extraíble. Hasta 50 MB.',
  'upload.aside.etaLabel':     'Tiempo estimado',
  'upload.aside.etaBody':      '5–15 minutos, según extensión y cola.',
  'upload.aside.privacyLabel': 'Privacidad',
  'upload.aside.privacyBody':  'Los PDF cargados se eliminan tras el análisis.',
  'nav.achievements':       'Logros',
  'nav.admin':              'Admin',
  'gam.kicker':             'Tu camino',
  'gam.heroLine':           'Lee, resuelve,',
  'gam.heroEm':             'sube de nivel',
  'gam.heroSub':            'Cada pregunta que respondes y cada libro que terminas gana XP e insignias. Sube de nivel y deja tu marca en la clasificación.',
  'gam.levelLabel':         'Nivel',
  'gam.xpTotal':            'XP total',
  'gam.xpUnit':             'XP',
  'gam.toNext':             'para el siguiente nivel',
  'gam.maxLevel':           'Nivel máximo',
  'gam.badges':             'Insignias',
  'gam.badgesSub':          'Marcas de tu aprendizaje',
  'gam.locked':             'Bloqueada',
  'gam.noBadges':           'Aún no hay insignias — empieza con tu primera pregunta.',
  'gam.leaderboard':        'Clasificación',
  'gam.leaderboardSub':     'Ranking de XP',
  'gam.rank':               'Puesto',
  'gam.you':                'Tú',
  'gam.emptyBoard':         'Aún no hay clasificación.',
  'gam.period.daily':       'Hoy',
  'gam.period.weekly':      'Esta semana',
  'gam.period.monthly':     'Este mes',
  'gam.period.all':         'Histórico',
  'gam.howXp':              'Cómo funciona el XP',
  'gam.howXpSub':           'Así se acumula el XP',
  'gam.levelCurve':         'Curva de niveles',
  'gam.levelN':             'Nv',
  'gam.aside.label':        '¿Qué es el XP?',
  'gam.aside.body':         'El XP es el registro acumulado de tu aprendizaje. Respuestas correctas, etapas completadas y libros terminados se suman en niveles.',
  'gam.aside.fairLabel':    'Ganancia justa',
  'gam.aside.fairBody':     'Responder la misma pregunta otra vez solo otorga XP una vez, en tu primer acierto.',
  'gam.xpRule.answer_correct':     'Respuesta correcta',
  'gam.xpRule.stage_complete':     'Etapa completada',
  'gam.xpRule.book_clear':         'Libro completado',
  'gam.xpRule.cr_submit':          'Respuesta escrita',
  'gam.xpRule.streak_day':         'Racha diaria',
  'gam.xpRule.question_propose':   'Proponer pregunta',
  'gam.xpRule.question_adopted':   'Pregunta adoptada',
  'gam.xpRule.review_participate': 'Participación en revisión',
  'detail.propose':            'Proponer una pregunta',
  'prop.title':                'Proponer una pregunta',
  'prop.help':                 'Escribe una pregunta de opción múltiple para este libro. Si un administrador la adopta, se une al banco de preguntas y ganas XP y una insignia.',
  'prop.stemLabel':            'Pregunta (enunciado)',
  'prop.stemPlaceholder':      'p. ej. ¿Por qué se marcha el protagonista en este capítulo?',
  'prop.choicesLabel':         'Opciones (selecciona la correcta)',
  'prop.choiceCorrect':        'Correcta',
  'prop.choicePlaceholder':    'Texto de la opción',
  'prop.explanationLabel':     'Explicación (opcional)',
  'prop.explanationPlaceholder': 'Justifica la respuesta con evidencia del texto.',
  'prop.submit':               'Enviar propuesta',
  'prop.submitting':           'Enviando…',
  'prop.success':              'Propuesta recibida. Te avisaremos si es adoptada.',
  'prop.needStem':             'Escribe el texto de la pregunta.',
  'prop.needChoices':          'Completa al menos dos opciones.',
  'prop.needCorrect':          'Selecciona la opción correcta.',
  'prop.myProposals':          'Mis propuestas',
  'prop.none':                 'Aún no hay propuestas.',
  'prop.status.pending':       'En revisión',
  'prop.status.accepted':      'Adoptada',
  'prop.status.rejected':      'Rechazada',
  'prop.aside.howLabel':       'Cómo funciona',
  'prop.aside.howBody':        'Propuesta → revisión del administrador → si se adopta entra al banco (se publica tras más control de calidad). Las mejores preguntas se adoptan más.',
  'prop.aside.rewardLabel':    'Recompensas',
  'prop.aside.rewardBody':     'Proponer da XP; la adopción da más XP y la insignia “Proponente de preguntas”.',
  'prop.difficulty':           'Dificultad sugerida (opcional)',
  'prop.difficultyNone':       'Sin especificar',
  'detail.report':            'Informe de logros',
  'quiz.celebration.viewReport': 'Ver informe',
  'report.kicker':            'Informe de evaluación',
  'report.title':             'Informe de logros',
  'report.accuracy':          'Precisión global',
  'report.level':             'Competencia',
  'report.theta':             'Estimación de habilidad (θ)',
  'report.thetaNote':         'Estimación relativa — aproximada, sin calibrar',
  'report.attempted':         'Resueltas',
  'report.unit':              'ítems',
  'report.naep':              'Dominios cognitivos NAEP',
  'report.lidia':             'Dominios LIDIA',
  'report.trend':             'Tendencia de progreso',
  'report.window':            'Periodo',
  'report.notAttempted':      'Sin responder',
  'report.empty':             'Aún no hay registros de evaluación',
  'report.emptySub':          'Resuelve preguntas y tu dominio por área aparecerá aquí.',
  'report.startQuiz':         'Iniciar evaluación',
  'report.honestyLabel':      'Sobre estas métricas',
  'report.honestyBody':       'Los niveles y θ son aproximaciones relativas sin calibrar, no puntuaciones estandarizadas (Lexile, notas de examen).',
  'report.viewCredential':    'Ver credencial',
  'report.viewAchievements':  'Logros · XP',
  'report.retry':             'Reintentar',
  'report.naep.locate_recall':       'Localizar y recordar',
  'report.naep.integrate_interpret': 'Integrar e interpretar',
  'report.naep.critique_evaluate':   'Criticar y evaluar',
  'footer.larc':              'Comité de revisión',
  'larc.kicker':             'Confianza y transparencia',
  'larc.title':              'Comité de revisión LARC',
  'larc.lead':               'Cada ítem se genera con IA y pasa una revisión en varias etapas. LARC hace público ese proceso.',
  'larc.missionLabel':       'Misión',
  'larc.missionBody':        'Protegemos la justicia y precisión de la evaluación. Los ítems generados por IA se verifican con personas y modelos cruzados para una medición fiable.',
  'larc.criteriaLabel':      'Criterios de revisión',
  'larc.crit1':              'Evidencia — ¿la respuesta se basa realmente en el texto?',
  'larc.crit2':              'Claridad — ¿el enunciado y las opciones son inequívocos?',
  'larc.crit3':              'Discriminación — ¿los distractores son plausibles y la clave única?',
  'larc.crit4':              'Nivel y sesgo — ¿apropiado para el nivel y sin sesgo?',
  'larc.statsLabel':         'Actividad de revisión',
  'larc.stApproved':         'Aprobados',
  'larc.stPending':          'En cola LARC',
  'larc.stReviewed':         'Revisados por IA',
  'larc.stRejected':         'Rechazados',
  'larc.stTotal':            'Ítems totales',
  'larc.stReports':          'Reportes resueltos',
  'larc.note':               'Solo se muestran totales agregados — sin datos personales ni contenido de ítems.',
  'prelearn.title':          'Preaprendizaje',
  'prelearn.subtitle':       'Contexto antes de leer',
  'prelearn.books':          'Comprar · librerías',
  'prelearn.media':          'Vídeo · contexto',
  'prelearn.note':           'Abre una búsqueda en un sitio externo.',
  'creds.summaryLabel':      'Credencial global de competencia',
  'creds.summaryTotal':      'Credenciales',
  'creds.summaryBooks':      'Libros cubiertos',
  'creds.summaryHighest':    'Nivel máximo',
  'nav.vault':               'Bóveda',
  'vault.title':             'Bóveda de conocimiento',
  'vault.subtitle':          'Reúne notas, citas e ideas',
  'vault.kindMemo':          'Nota',
  'vault.kindQuote':         'Cita',
  'vault.kindInsight':       'Idea',
  'vault.kindFeedback':      'Comentario',
  'vault.contentPlaceholder': 'Escribe lo que quieras recordar',
  'vault.tagsPlaceholder':   'Etiquetas (separadas por comas)',
  'vault.add':               'Guardar',
  'vault.searchPlaceholder': 'Buscar contenido',
  'vault.allKinds':          'Todas',
  'vault.empty':             'Aún no hay notas guardadas.',
  'vault.delete':            'Eliminar',
  'vault.added':             'Guardado.',
  'vault.deleted':           'Eliminado.',
  'vault.needContent':       'Escribe algún contenido.',
  'vault.export':            'Exportar',
  'vault.exportMd':          'Markdown',
  'vault.exportJson':        'JSON',
  'verify.title':            'Verificación de credencial',
  'verify.checking':         'Verificando…',
  'verify.valid':            'Credencial válida',
  'verify.invalid':          'Credencial inválida o revocada',
  'verify.notFound':         'Credencial no encontrada',
  'verify.tier':             'Nivel',
  'verify.issued':           'Emitida',
  'verify.note':             'Verificada con los registros de emisión de BookQuest. No se expone ningún dato personal.',
};

export default es;
